import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f8746416")

_pushScopeId("data-v-f8746416")
const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "visually-hidden" }, "Cargando...")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "bi bi-pencil" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "edit-mode"
}
const _hoisted_5 = {
  value: "",
  disabled: ""
}
const _hoisted_6 = {
  value: "",
  disabled: ""
}
const _hoisted_7 = { class: "button-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShowConfirmation = _resolveComponent("ShowConfirmation")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        _createVNode("div", null, [
          (_ctx.isLoadingOrganizations)
            ? (_openBlock(), _createBlock("div", _hoisted_1, [
                _hoisted_2
              ]))
            : _createCommentVNode("", true),
          (!_ctx.editMode && !_ctx.isLoadingOrganizations)
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: ["clickable-display", { 'warning-state': _ctx.isWarningState }]
              }, [
                _createVNode("p", null, _toDisplayString(_ctx.$t("hierarchy")) + ": " + _toDisplayString(_ctx.userHierarchyLevel
            ? _ctx.$t(`userHierarchyLevel.${_ctx.userHierarchyLevel}`)
            : _ctx.$t("none")), 1),
                _createVNode("p", null, _toDisplayString(_ctx.$t("area")) + ": " + _toDisplayString(_ctx.userDepartment ? _ctx.$t(`userDepartment.${_ctx.userDepartment}`) : _ctx.$t("none")), 1),
                _createVNode("div", {
                  class: "edit-icon",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleEditMode && _ctx.toggleEditMode(...args)), ["stop"]))
                }, [
                  _hoisted_3
                ])
              ], 2))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withId(() => [
        (_ctx.editMode)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedHierarchyLevel = $event))
              }, [
                _createVNode("option", _hoisted_5, _toDisplayString(_ctx.$t("userHierarchyLevel.selectHierarchy")), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hierarchyLevels, (level) => {
                  return (_openBlock(), _createBlock("option", {
                    key: level,
                    value: level
                  }, _toDisplayString(_ctx.$t(`userHierarchyLevel.${level}`)), 9, ["value"]))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedHierarchyLevel]
              ]),
              _withDirectives(_createVNode("select", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedDepartment = $event))
              }, [
                _createVNode("option", _hoisted_6, _toDisplayString(_ctx.$t("userDepartment.selectArea")), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.areas, (area) => {
                  return (_openBlock(), _createBlock("option", {
                    key: area,
                    value: area
                  }, _toDisplayString(_ctx.$t(`userDepartment.${area}`)), 9, ["value"]))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.selectedDepartment]
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args))),
                  disabled: !_ctx.selectedDepartment || !_ctx.selectedHierarchyLevel
                }, _toDisplayString(_ctx.$t("confirm")), 9, ["disabled"]),
                (_ctx.status !== 'pending')
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                    }, _toDisplayString(_ctx.$t("cancel")), 1))
                  : (_openBlock(), _createBlock("button", {
                      key: 1,
                      class: "btn btn-danger ps-6 me-1",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModal(_ctx.organization.id))),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#_app_organization_procede",
                      "data-bs-placement": "top"
                    }, _toDisplayString(_ctx.$t("Rechazar")), 1))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ShowConfirmation)
  ], 64))
})